import { Typography } from "@mui/material";
import {
  StyledRoot,
  StyledToolbar,
  StyledLogo,
} from "./Topbar.styles";
import logo from "../../assets/images/guardianonetransport_logo.png";
import AccountPopover from "../AccountPopover/AccountPopover";
import SchoolSelector from "../SchoolSelector/SchoolSelector";

import { StyledIconBtn } from "../../configs/GoStyles";
import DragHandleIcon from '@mui/icons-material/DragHandle';

const Topbar = ({ isOpen, setIsOpen }: any) => {

  const toggleDrawer = (open: any) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsOpen(open);
  };

  return (
    <StyledRoot>
      <StyledToolbar>
        <StyledLogo src={logo} alt="logo" />
        <StyledIconBtn onClick={toggleDrawer(true)}
          sx={{
            mr: 1,
            display: { lg: "none" },
          }}>
          <DragHandleIcon />
        </StyledIconBtn>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1 }}
        ></Typography>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center", alignSelf: "center" }}>
          {/* <SchoolSelector /> */}
          <AccountPopover />
        </div>
      </StyledToolbar>
    </StyledRoot>
  );
};

export default Topbar;
